import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet, withServerErrorCode } from '@plone/volto/helpers';

// 0.3.7: branded 404 (status code still set by Volto's SSR error handling).
const NotFound = () => (
  <div className="gf-wrap gf-404" id="page-not-found">
    <Helmet title="Page not found" />
    <div className="gf-404-code">404</div>
    <h1>This page can't be found.</h1>
    <p>The link may be old or mistyped. Here are a few places to start.</p>
    <div className="gf-404-links">
      <Link to="/" className="gf-btn">Home</Link>
      <Link to="/collections" className="gf-btn">Collections</Link>
      <Link to="/request-a-quote" className="gf-btn gf-btn-dark">Connect</Link>
    </div>
  </div>
);
export default withServerErrorCode(404)(NotFound);
